module.exports = __webpack_public_path__ + "img/guide09.26145ee9.jpg";